<template>
    <sky />
    <div class="aboutus">
        <div class="shadow"></div>
        <p class="t1">吉利数科区块链介绍</p>
        <p class="t2">ABOUT GEELY DIGITAL TECHNOLOGY BLOCKCHAIN</p>
        <p class="t3">吉利数科区块链拥有自主研发的区块链底层，并向市场提供开放的联盟链服务，<br/> 应用场景包括数字营销、供应链溯源、供应链金融、碳足迹追踪、碳交易等。</p>
        <p class="t4">Geely Digital Blockchain has a self-developed underlying blockchain and provides open consortium chain services to the market. Application scenarios include digital marketing, supply chain traceability, supply chain finance, carbon footprint tracking, carbon trading, etc.</p>
    
    </div>
</template>
<script>
import Sky from '../components/Sky.vue'
export default {
  components: { Sky },
    
}
</script>
<style scoped>
@import url(~@/styles/aboutus.css);
</style>